import axios from "axios";
import * as myConstClass from "../Config/config.js";
import { Encrypt } from "../Helpers/Common"; //Include Home
const END_POINT = myConstClass.BACKEND_ENDPOINT;
const AUTH_TOKEN = myConstClass.AUTH_TOKEN;

const headers = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Credentials": true,
  "x-access-auth-token": "" + AUTH_TOKEN + "",
  "country": localStorage.getItem("country")
};

//Get Page Content
export async function page(page, country, is_child, page_no, page_size) {
  if (localStorage.getItem("is_child_local_storage") == "true") {
    var nischild = true
  } else {
    var nischild = false
  }
  var userNumber = Number(localStorage.getItem("userID"))
  var postData = {
    page_type: page,
    x_country: localStorage.getItem("country"),
    is_child: nischild,
    page_no: page_no,
    page_size: page_size,
    user_id: userNumber,
    session_id: localStorage.getItem("session_id")
  };
  return await axios.post(END_POINT + "/pages/home", postData, { headers: headers }).then((res) => {
    return res;
  });
}

export async function getUserRecommendation(page, country, is_child, page_no, page_size) {
  var postData = {
    page_type: page,
    x_country: country,
    is_child: is_child,
    page_no: page_no,
    page_size: page_size
  };

  return await axios.post(END_POINT + "/pages/getUserRecommendation", postData, { headers: headers, }).then((res) => {
    return res;
  });
}

export async function BaypageM(slug) {
  var postData = {
    page_type: slug,
    x_country: localStorage.getItem("country") ? localStorage.getItem("country") : "IN"
  };
  return await axios
    .post(END_POINT + "/pages/bay_page/" + slug, postData, {
      headers: headers,
    })
    .then((res) => {
      return res;
    });
}

export async function GetPlayurl(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/content/playurl", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function GetLivetv() {
  return axios
    .post(END_POINT + "/content/livetv", "", {
      headers: headers,
      mode: "cors",
    })
    .then((res) => {
      const persons = res;
      return persons;
    });
}

export async function Docubytes(start, end) {
  return axios
    .post(END_POINT + "/content/docubytes", "", {
      headers: headers,
      mode: "cors",
    })
    .then((res) => {
      return res;
    });
}
//Get Content Details

export async function ContentDetails(page, country) {
  return axios.get(END_POINT + "/pages/details/" + page + "/?x_country=" + country, {
    headers: headers,
  }).then((res) => {
    return res;
  });
}

export async function RelatedContent(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/content/related", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

//Get Search Details
export async function DefaultSearch(country) {
  return axios
    .post(END_POINT + "/content/default-search" + "?x_country=" + country, "", {
      headers: headers,
    })
    .then((res) => {
      const data = res;
      return data;
    });
}

export async function Genrelist(req) {
  return await Encrypt(req).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/content/genrelist", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function SearchKeyword(req, country) {
  return await Encrypt(req).then(async (res) => {
    const postData = {
      digest: res,
    };
    const res_2 = await axios.post(END_POINT + "/content/keywordSearch" + "?x_country=" + country, postData, {
      headers: headers,
    });
    const data = res_2;
    return data;
  });
}

//Add to watch list

export async function Addtowatchlist(req) {
  return await Encrypt(req).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/content/keywordSearch", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

//remove from watch list

export async function Removefromwatchlist(req) {
  return await Encrypt(req).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/content/keywordSearch", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function GetUserData() {
  const data = localStorage.getItem("user-info");
  return data;
}

export async function GetSeasons(req) {
  return await Encrypt(req).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/content/season", postData, {
        headers: headers,
      })
      .then((res) => {
        return res;
      });
  });
}
